import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Card from "react-bootstrap/Card";
import NavDropdown from "react-bootstrap/NavDropdown";
import { logDOM } from "@testing-library/react";
import Nav from "react-bootstrap/Nav";
import Button from "@mui/material/Button";
import ListSubheader from "@mui/material/ListSubheader";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import HandshakeIcon from "@mui/icons-material/Handshake";
import InventoryIcon from "@mui/icons-material/Inventory";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import PaidIcon from "@mui/icons-material/Paid";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getMenu } from "../redux/handlers/auth/getMenu.handler";
var StyledListHeader = styled(ListSubheader)({
    backgroundImage: "var(--Paper-overlay)"
});
export function Menutop(param) {
    var selectbranchID = param.selectbranchID, setSelectBranchID = param.setSelectBranchID;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var _useState = _sliced_to_array(useState(0), 2), menuTopNew = _useState[0], setMenuTopNew = _useState[1];
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var location = useLocation();
    var hash = location.hash, pathname = location.pathname, search = location.search;
    var _useState1 = _sliced_to_array(useState([]), 2), menulists = _useState1[0], setMenulists = _useState1[1];
    var _React_useState = _sliced_to_array(React.useState(null), 2), anchorEl = _React_useState[0], setAnchorEl = _React_useState[1];
    var open = Boolean(anchorEl);
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var iconMap = {
        BusinessCenterIcon: BusinessCenterIcon,
        HandshakeIcon: HandshakeIcon,
        InventoryIcon: InventoryIcon,
        HistoryEduIcon: HistoryEduIcon,
        PaidIcon: PaidIcon,
        TrendingUpIcon: TrendingUpIcon,
        AccountCircleIcon: AccountCircleIcon,
        SettingsIcon: SettingsIcon,
        AirportShuttleIcon: AirportShuttleIcon,
        Inventory2OutlinedIcon: Inventory2OutlinedIcon,
        PointOfSaleIcon: PointOfSaleIcon
    };
    var getMenuReducer = useAppSelector(function(state) {
        return state.getMenuReducer;
    });
    useEffect(function() {
        dispatch(getMenu({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(getMenuReducer.isFetching);
        if (getMenuReducer.data) {
            setMenulists(getMenuReducer.data.data);
        // console.log('getMenuReducer.data', getMenuReducer.data.data);
        }
    }, [
        getMenuReducer
    ]);
    useEffect(function() {
        var fetchData = function() {
            var _ref = _async_to_generator(function() {
                var getPathUrl, path_array, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                pathname.substring(1)
                            ];
                        case 1:
                            getPathUrl = _state.sent();
                            return [
                                4,
                                getPathUrl.split("/")
                            ];
                        case 2:
                            path_array = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Error fetching data:", error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            console.log("Component is unmounted.");
        };
    }, [
        menuTopNew
    ]);
    var handleNavigation = function(url) {
        window.location.href = url;
        handleClose();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "scroll-menu mb-2",
        children: [
            isMobile && /*#__PURE__*/ _jsxs("div", {
                className: "d-flex flex-wrap",
                style: {
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        id: "basic-button",
                        "aria-controls": open ? "grouped-menu" : undefined,
                        "aria-haspopup": "true",
                        "aria-expanded": open ? "true" : undefined,
                        onClick: handleClick,
                        variant: "contained",
                        color: "error",
                        fullWidth: true,
                        children: "เมนู"
                    }),
                    /*#__PURE__*/ _jsx(Menu, {
                        id: "grouped-menu",
                        anchorEl: anchorEl,
                        open: open,
                        onClose: handleClose,
                        slotProps: {
                            list: {
                                "aria-labelledby": "basic-button",
                                sx: {
                                    py: 0
                                }
                            },
                            paper: {
                                sx: {
                                    mt: 3.5,
                                    width: "93%",
                                    maxWidth: "93%"
                                }
                            }
                        },
                        children: menulists.filter(function(menu) {
                            return menu.SysMenu.sys_menu_level === 0;
                        }).map(function(menu, idx) {
                            return menu.SysMenu.sys_menu_type === "Module" && /*#__PURE__*/ _jsx(_Fragment, {
                                children: /*#__PURE__*/ _jsxs(MenuItem, {
                                    disabled: menu.SysMenu.sys_menu_show === 2 ? true : false,
                                    onClick: function() {
                                        handleNavigation(menu.SysMenu.sys_menu_masterkey);
                                    },
                                    children: [
                                        menu.SysMenu.sys_menu_icon && iconMap[menu.SysMenu.sys_menu_icon] && /*#__PURE__*/ React.createElement(iconMap[menu.SysMenu.sys_menu_icon], {
                                            className: "icon-menu-st-1 mr-1 mb-1"
                                        }),
                                        " ",
                                        menu.SysMenu.sys_menu_name
                                    ]
                                }, idx)
                            }) || menu.SysMenu.sys_menu_type === "Group" && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsxs(StyledListHeader, {
                                        disabled: menu.SysMenu.sys_menu_show === 2 ? true : false,
                                        children: [
                                            menu.SysMenu.sys_menu_icon && iconMap[menu.SysMenu.sys_menu_icon] && /*#__PURE__*/ React.createElement(iconMap[menu.SysMenu.sys_menu_icon], {
                                                className: "icon-menu-st-1 mr-1 mb-1"
                                            }),
                                            " ",
                                            menu.SysMenu.sys_menu_name
                                        ]
                                    }, idx),
                                    menulists.filter(function(menu2) {
                                        return menu2.SysMenu.sys_menu_level === 1 && menu2.SysMenu.sys_menu_parent === menu.sys_permission_menuid;
                                    }).map(function(menu2, ix) {
                                        return /*#__PURE__*/ _jsxs(MenuItem, {
                                            href: menu2.SysMenu.sys_menu_masterkey,
                                            disabled: menu2.SysMenu.sys_menu_show === 2 ? true : false,
                                            onClick: function() {
                                                handleNavigation(menu2.SysMenu.sys_menu_masterkey);
                                            },
                                            sx: {
                                                pl: 5
                                            },
                                            children: [
                                                "• ",
                                                menu2.SysMenu.sys_menu_name
                                            ]
                                        }, idx);
                                    })
                                ]
                            });
                        })
                    })
                ]
            }),
            !isMobile && /*#__PURE__*/ _jsx(Card, {
                className: "card card-menu",
                children: /*#__PURE__*/ _jsx(Card.Body, {
                    className: "d-flex flex-wrap",
                    style: {
                        paddingBottom: "0vw",
                        paddingTop: "0vw",
                        paddingRight: "0vw",
                        paddingLeft: "0vw"
                    },
                    children: /*#__PURE__*/ _jsx(Nav, {
                        variant: "pills",
                        className: "justify-content-center pills-st-menu-1",
                        activeKey: menuTopNew,
                        children: menulists.filter(function(menu) {
                            return menu.SysMenu.sys_menu_level === 0;
                        }).map(function(menu, idx) {
                            return menu.SysMenu.sys_menu_type === "Module" && /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    eventKey: menu.SysMenu.sys_menu_masterkey,
                                    href: menu.SysMenu.sys_menu_masterkey,
                                    disabled: menu.SysMenu.sys_menu_show === 2 ? true : false,
                                    children: [
                                        menu.SysMenu.sys_menu_icon && iconMap[menu.SysMenu.sys_menu_icon] && /*#__PURE__*/ React.createElement(iconMap[menu.SysMenu.sys_menu_icon], {
                                            className: "icon-menu-st-1 mr-1"
                                        }),
                                        " ",
                                        menu.SysMenu.sys_menu_name
                                    ]
                                })
                            }, idx) || menu.SysMenu.sys_menu_type === "Group" && /*#__PURE__*/ _jsx(NavDropdown, {
                                title: /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        menu.SysMenu.sys_menu_icon && iconMap[menu.SysMenu.sys_menu_icon] && /*#__PURE__*/ React.createElement(iconMap[menu.SysMenu.sys_menu_icon], {
                                            className: "icon-menu-st-1 mr-1"
                                        }),
                                        " ",
                                        menu.SysMenu.sys_menu_name
                                    ]
                                }),
                                children: /*#__PURE__*/ _jsx(_Fragment, {
                                    children: menulists.filter(function(menu2) {
                                        return menu2.SysMenu.sys_menu_level === 1 && menu2.SysMenu.sys_menu_parent === menu.sys_permission_menuid;
                                    }).map(function(menu2, ix) {
                                        return /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                            eventKey: menu2.SysMenu.sys_menu_masterkey,
                                            href: menu2.SysMenu.sys_menu_masterkey,
                                            disabled: menu2.SysMenu.sys_menu_show === 2 ? true : false,
                                            children: menu2.SysMenu.sys_menu_name
                                        }, ix);
                                    })
                                })
                            }, idx);
                        })
                    })
                })
            })
        ]
    });
}
